<template>
	<div id="avaliation">
		<div class="content-review container">
			<div class="content-review-header">
				<h2>Avaliação clientes</h2>
			</div>
			<div class="content-review-classification">
				<div class="content-item rate">
					<div class="content-classification">
						<p>{{ partner.rate }}</p>
						<svg
								xmlns="http://www.w3.org/2000/svg"
								width="34.657"
								height="33.171"
								viewBox="0 0 34.657 33.171"
						>
								<path
										d="M35.969,1.141l-4.23,8.577L22.275,11.1a2.074,2.074,0,0,0-1.147,3.537l6.847,6.672-1.619,9.425a2.072,2.072,0,0,0,3.006,2.183l8.467-4.45,8.467,4.45A2.073,2.073,0,0,0,49.3,30.733l-1.62-9.425,6.847-6.672A2.074,2.074,0,0,0,53.382,11.1l-9.464-1.38-4.23-8.577a2.075,2.075,0,0,0-3.718,0Z"
										transform="translate(-20.5 0.013)"
										fill="#fff"
								/>
						</svg>
					</div>
					<template v-if="opinion.total_comment > 1">
						<div class="content-quantity-coments">
							<p>{{ opinion.total_comment }} comentários</p>
						</div>
					</template>
					<template v-else>
						<div class="content-quantity-coments" v-if="total_comments == 1">
							<p>{{ total_comments }} comentário</p>
						</div>
						<div class="content-quantity-coments" v-else>
							<p>{{ total_comments }} comentários</p>
						</div>
					</template>
				</div>
				<div class="content-item" v-if="userIsLogged">
					<button class="btn-opinion" @click="$bvModal.show('modal-opinion')">Deixe a sua opinião</button>
				</div>
				<div class="content-item" v-else>
					<button class="btn-opinion" @click="alertLogin()">Deixe a sua opinião</button>
				</div>
			</div>
			<div class="content-review-body" v-if="showLess">
				<div class="content-card-coment" v-for="(n, index) in opinion.slice(0, 3)" :key="index">
					<div class="content-card-coment-element-one">
						<div class="content-card-coment-element-avaliation">
							<p>{{ n.rate }}</p>
							<svg
									xmlns="http://www.w3.org/2000/svg"
									width="16.943"
									height="16.216"
									viewBox="0 0 16.943 16.216"
							>
									<path
											d="M28.062.551,25.994,4.744l-4.627.675a1.014,1.014,0,0,0-.561,1.729l3.347,3.262-.792,4.608a1.013,1.013,0,0,0,1.469,1.067l4.139-2.176,4.139,2.176a1.014,1.014,0,0,0,1.469-1.067l-.792-4.608,3.347-3.262a1.014,1.014,0,0,0-.561-1.729l-4.627-.675L29.88.551a1.014,1.014,0,0,0-1.818,0Z"
											transform="translate(-20.5 0.013)"
											fill="#fff"
									/>
							</svg>
						</div>
						<div class="content-card-coment-element-name">
							<p>{{ n.user_id }}</p>
							<p>{{ n.date }}</p>
						</div>
					</div>
					<div class="content-card-coment-element-two">
						<div class="content-card-coment-element-text">
							<p>{{ n.comment }}</p>
						</div>
					</div>
				</div>
				<button class="btn-view-more" v-if="opinion.length > 3" @click="showLess = false">Ver mais</button>
			</div>
			<div class="content-review-body" v-else>
				<div class="content-card-coment" v-for="(n, index) in opinion" :key="index">
					<div class="content-card-coment-element-one">
						<div class="content-card-coment-element-avaliation">
							<p>{{ n.rate }}</p>
							<svg
									xmlns="http://www.w3.org/2000/svg"
									width="16.943"
									height="16.216"
									viewBox="0 0 16.943 16.216"
							>
									<path
											d="M28.062.551,25.994,4.744l-4.627.675a1.014,1.014,0,0,0-.561,1.729l3.347,3.262-.792,4.608a1.013,1.013,0,0,0,1.469,1.067l4.139-2.176,4.139,2.176a1.014,1.014,0,0,0,1.469-1.067l-.792-4.608,3.347-3.262a1.014,1.014,0,0,0-.561-1.729l-4.627-.675L29.88.551a1.014,1.014,0,0,0-1.818,0Z"
											transform="translate(-20.5 0.013)"
											fill="#fff"
									/>
							</svg>
						</div>
						<div class="content-card-coment-element-name">
							<p>{{ n.user_id }}</p>
							<p>{{ n.date }}</p>
						</div>
					</div>
					<div class="content-card-coment-element-two">
						<div class="content-card-coment-element-text">
							<p>{{ n.comment }}</p>
						</div>
					</div>
				</div>
				<button class="btn-view-more" @click="showLess = true">Ver menos</button>
			</div>
		</div>
		<ModalOpinion />
	</div>
</template>

<script>
import ModalOpinion from '@/components/modals/ModalOpinion';
import { mapGetters } from 'vuex';

export default {
	data() {
		return {
			showLess: true,
		}
	},
	components: {
		ModalOpinion
	},
	props: ['partner', 'opinion', 'total_comments'],
	computed: {
		...mapGetters("User", ['userIsLogged']),
		...mapGetters({
			user: 'User/user',
		})
	},
	methods: {
		alertLogin() {
			this.$fire({
				type: "info",
				title: "Atenção",
				text: "É necessário fazer login para comentar.",
				timer: 3000,
				showConfirmButton: true,
			})
		},
  },
}
</script>

<style lang="scss" scoped>
.content-review {
    padding: 0px 15px 100px 15px;
    @media (max-width: 991px) {
        padding: 50px 15px;
    }
    &-header {
        text-align: left;
        margin-bottom: 50px;
        h2 {
            font-size: 40px;
            font-family: "Font Bold";
            color: var( --green-medium);
            margin-bottom: 0px;
            @media screen and (max-width: 991px) {
                font-size: 28px;
            }
        }
    }
    &-classification {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 50px;
        @media (max-width: 991px) {
            flex-direction: row;
            align-items: flex-start;
        }
        .rate{
            gap: 25px;
            @media screen and (max-width: 991px) {
                flex-direction: column!important;
            }
        }
        .content-item {
            display: flex;
            align-items: center;
            flex-direction: row;
            @media (max-width: 991px) {
                align-items: flex-start;
            }
            .content-classification {
                width: 140px;
                height: 65px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: #e69c5a;
                border: 1px solid #e69c5a;
                border-radius: 8px;
                margin-right: 30px;
                transition: 500ms;
                @media (max-width: 1199px) {
                    width: 100px;
                    height: 50px;
                    margin-right:0px;
                    align-content: flex-start;
                }
                &:hover,
                &:focus {
                    cursor: pointer;
                    opacity: 0.8;
                }
                p {
                    font-size: 33px;
                    font-family: "Font Bold";
                    color: var(--white);
                    margin-right: 15px;
                    margin-bottom: 0;
                    @media (max-width: 1199px) {
                        font-size: 20px;
                    }
                }
                svg {
                    @media (max-width: 1199px) {
                        max-width: 25px;
                    }
                    @media (max-width: 991px) {
                        max-width: 20px;
                    }
                }
            }
            .content-quantity-coments {
                p {
                    font-size: 26px;
                    font-family: "Font Regular";
                    color: var( --green-dark);
                    margin-bottom: 0;
                    @media (max-width: 1199px) {
                        font-size: 18px;
                    }
                    @media (max-width: 991px) {
                        font-size: 18px;
                    }
                }
            }
            .content-elements-score {
                display: flex;
                align-items: center;
                margin-right: 40px;
                @media (max-width: 1199px) {
                    margin-right: 20px;
                }
                @media (max-width: 991px) {
                    margin-bottom: 10px;
                }
                &:last-child {
                    margin-right: 0;
                }
                &-star {
                    width: 67px;
                    height: 36px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: var(--white);
                    border: 1px solid #e69c5a;
                    border-radius: 8px;
                    margin-right: 15px;
                    @media (max-width: 1199px) {
                        width: 60px;
                    }
                    p {
                        font-size: 22px;
                        font-family: "Font Bold";
                        color: #e69c5a;
                        margin-right: 10px;
                        margin-bottom: 0;
                        @media (max-width: 1199px) {
                            font-size: 18px;
                        }
                    }
                }
                &-quantity {
                    p {
                        font-size: 26px;
                        font-family: "Font Regular";
                        color: var( --green-dark);
                        margin-bottom: 0;
                        @media (max-width: 1199px) {
                            font-size: 18px;
                        }
                    }
                }
            }
            button{
                all:unset;
                cursor: pointer;
                width: 203px;
                height: 45px;
                border: 1px solid var(--green-medium);
                background: var(--green-medium);
                box-shadow: 5px 5px 5px #00000016;
                color: var(--white);
                font-size: 18px;
                font-family: "Font Regular", sans-serif;
                border-radius: 8px;
                transition: 500ms;
                &:hover,
                &:focus {
                    background-color: var(--white);
                    color: var(--green-medium);
                    opacity: 0.8;
                }
            }

        }
    }
    &-body {
        .content-card-coment {
            padding: 30px 20px;
            background: var(--white);
            border: 1px solid #e7e7e7;
            border-radius: 10px;
            box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.05);
            display: flex;
            justify-content: space-between;
            margin-bottom: 50px;
            @media (max-width: 991px) {
                flex-direction: column;
                margin-bottom: 30px;
            }
            &-element {
                &-one {
                    width: 160px;
                    margin-right: 80px;
                    @media (max-width: 991px) {
                        width: 100%;
                        display: flex;
                        gap: 30px;
                        margin-right: 0;
                        margin-bottom: 30px;
                    }
                }
                &-two {
                    width: calc(100% - 240px);
                    @media (max-width: 991px) {
                        width: 100%;
                    }
                }
                &-avaliation {
                    width: 67px;
                    height: 36px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: #e69c5a;
                    border-radius: 8px;
                    margin-bottom: 20px;
                    margin-top: 6px;
                    p {
                        font-size: 22px;
                        font-family: "Font Bold";
                        color: var(--white);
                        margin-right: 10px;
                        margin-bottom: 0;
                        @media (max-width: 991px) {
                            font-size: 18px;
                        }
                    }
                }
                &-name {
                    text-align: left;
                    p {
                        font-size: 22px;
                        font-family: "Font Regular";
                        color: #b7b8b8;
                        margin-bottom: 0px;
                        @media (max-width: 1199px) {
                            font-size: 18px;
                        }
                    }
                }
                &-text {
                    text-align: left;
                    h3 {
                        font-size: 22px;
                        font-family: "Font Bold";
                        color: var( --green-dark);
                        margin-bottom: 12px;
                        @media (max-width: 1199px) {
                            font-size: 18px;
                        }
                    }
                    p {
                        font-size: 22px;
                        font-family: "Font Regular";
                        color: #555555;
                        display: -webkit-box;
                        -webkit-line-clamp: 4 !important;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                        margin-bottom: 0;
                        @media (max-width: 1199px) {
                            font-size: 18px;
                        }
                    }
                }
            }
        }
        .btn-view-more {
            width: 133px;
            height: 45px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: var( --green-medium);
            border: 1px solid var( --green-medium);
            box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.16);
            border-radius: 10px;
            font-size: 18px;
            font-family: "Font Regular";
            color: var(--white);
            margin: 0 auto;
            transition: 500ms;
            &:hover,
            &:focus {
                cursor: pointer;
                background: var(--white);
                color: var( --green-medium);
            }
        }
    }
}
</style>